import request from '@/utils/request'

// 获取知识图文工作流配置
export function getCurrentDifyConfig () {
  return request.get('/system/dify-config/current')
}

// 保存知识图文工作流配置
export function saveDifyConfig (data) {
  return request.post('/system/dify-config/save', data)
}
